// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-search"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22 17.75C22 19.8211 20.3211 21.5 18.25 21.5C16.1789 21.5 14.5 19.8211 14.5 17.75C14.5 15.6789 16.1789 14 18.25 14C20.3211 14 22 15.6789 22 17.75Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 11V3H2V17H11M4 21H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.9036 20.3997L22.5 22M22 17.75C22 19.8211 20.3211 21.5 18.25 21.5C16.1789 21.5 14.5 19.8211 14.5 17.75C14.5 15.6789 16.1789 14 18.25 14C20.3211 14 22 15.6789 22 17.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemSearchIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-search',
    ref,
    icon: element,
  },
));

SystemSearchIcon.displayName = 'SystemSearchIcon';

export default SystemSearchIcon;
